import React from "react";
import RFamily from "../../PicesForPages/FHAVAStreamline.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function FhaVaStreamline() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent FhaVaStreamlinePageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={RFamily}
          alt="RFamilyImage"
          className="background-video FHAVAStreamlineImage"
        />
        <div className="purchasetopBox FhaVaStreamlinePageTopBox">
          {/* The existing Purchase span */}
          <span>FHA VA Streamline Refinance</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">
              Are you currently holding an FHA or VA Loan?
            </span>
            <span className="purchaseBottomLeftContent">
              We have a solution for you – the Streamline Program! You could
              skip a monthly mortgage payment and even receive cash back after
              closing. This could mean hundreds of dollars in your pocket!
            </span>

            <span className="purchaseBottomLeftHeader">
              Check out the perks!
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Reduced monthly mortgage payments</li>
              <li>Lower interest rate</li>
              <li>No out-of-pocket expenses</li>
              <li>No credit score requirements</li>
              <li>Options for 15, 20, or 30-year terms </li>
            </ul>

            <span className="purchaseBottomLeftHeader">
              Streamline Refinance
            </span>
            <span className="purchaseBottomLeftContent">
              This refinance option works much like the FHA Streamline Program,
              requiring minimal documentation. Additionally, we offer exclusive
              purchase programs for Veterans!
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default FhaVaStreamline;
